import React from "react";
import "./LoaderLuxe.css";

const LoaderLuxe = () => (
  <div className="loader-luxe-container">
    <div className="loader-luxe-logo">
      <div className="gold-pulse"></div>
      <span className="loader-text">MARCHÉ DE LUXE</span>
    </div>
  </div>
);

export default LoaderLuxe;
